:host {
  display: block;
  color: $color-typography-typo-88;
}

* {
  margin: 0;
  padding: 0;
}

.headline-1 {
  font-family: $asset-font-gotham-black-name;
  font-size: $size-typography-headline-1;
  line-height: $size-line-height-headline-1;
}

.headline-2 {
  font-family: $asset-font-gotham-black-name;
  font-size: $size-typography-headline-2;
  line-height: $size-line-height-headline-2;
}

.headline-3 {
  font-family: $asset-font-gotham-black-name;
  font-size: $size-typography-headline-3;
  line-height: $size-line-height-headline-3;
}

.headline-4 {
  font-family: $asset-font-gotham-black-name;
  font-size: $size-typography-headline-4;
  line-height: $size-line-height-headline-4;
}

.headline-5 {
  font-family: $asset-font-gotham-black-name;
  font-size: $size-typography-headline-5;
  line-height: $size-line-height-headline-5;
}

.headline-6 {
  font-family: $asset-font-gotham-bold-name;
  font-size: $size-typography-headline-6;
  line-height: $size-line-height-headline-6;
}

.subtitle-1 {
  font-family: $asset-font-gotham-bold-name;
  font-size: $size-typography-subtitle-1;
  line-height: $size-line-height-subtitle-1;
}

.subtitle-2 {
  font-family: $asset-font-gotham-book-name;
  font-size: $size-typography-subtitle-2;
  line-height: $size-line-height-subtitle-2;
}

.bodytext-1 {
  font-family: $asset-font-gotham-bold-name;
  font-size: $size-typography-bodytext-1;
  line-height: $size-line-height-bodytext-1;
}

.bodytext-2 {
  font-family: $asset-font-gotham-book-name;
  font-size: $size-typography-bodytext-2;
  line-height: $size-line-height-bodytext-2;
}

.caption {
  font-family: $asset-font-gotham-book-name;
  font-size: $size-typography-caption;
  line-height: $size-line-height-caption;
}

.overline {
  font-family: $asset-font-gotham-bold-name;
  font-size: $size-typography-overline;
  line-height: $size-line-height-overline;
}
